import { get } from 'lodash';

import app from '../../scripts/app';

import template from './publish-terms-vc-only.jade';

const serviceTypesDir = {
  premium: 'PremiumObject',
  highlight: 'Highlight',
  paid: 'DebitObject',
  top3: 'Top3',
  free: 'FreeObject',
};

app.directive('cianAfPublishTermsVcOnly', [function() {
  return {
    template,
    scope: {},
    bindToController: {
      highlightOption: '=',
      offerTerms: '=',
      onTermsChange: '&',
    },
    controller: ['$filter', '$sce', function($filter, $sce) {
      this.selectPeriod = (period = get(this.highlightOption, 'publishOptions.periods[0]')) => {
        this.selectedPeriod = period;
        this.selectedPeriod.services = this.highlightOption.services;

        const $terms = [].concat(this.offerTerms, this.selectedPeriod)
          .map(term => ({
            days: term.days,
            serviceTypes: term.services.map(service => serviceTypesDir[service]),
            periodType: term.type,
            tariffIdentificator: term.tariffIdentificator
          }));

        this.onTermsChange({$terms});
      };

      this.selectPeriod();

      this.getPeriodPrice = () => this.selectedPeriod.price;
      this.getPeriodDays = () => this.selectedPeriod.days;
      this.getPaymentPeriodLabel = () => {
        if (this.selectedPeriod.key === 'DailyTermless-1') {
          return 'Способ оплаты: посуточно';
        }

        const formattedDate = $filter('date')(this.selectedPeriod.endDate, 'longDate');
        return `Срок размещения: до ${formattedDate}`;
      };

      this.periodDaysPluralize = {
        1: 'сутки',
        one: '{} день',
        few: '{} дня',
        many: '{} дней'
      };
    }],
    controllerAs: 'publishTermsVcOnlyCtrl'
  }
}]);
